import React from "react";
import { useTranslation } from "react-i18next";
import WhatsupIcon from "../../../../assets/profile/media/whatsup.svg";
import EmailIcon from "../../../../assets/profile/media/email.svg";
import FacebookIcon from "../../../../assets/profile/media/facebook.svg";
import LinkedinIcon from "../../../../assets/profile/media/linkedin.svg";

export const AffiliatesSharingOptions = ({
  linkValue,
}: {
  linkValue: string;
}) => {
  const { t } = useTranslation(["profile"]);

  const openCenteredWindow = (url: string, width: number, height: number) => {
    const left = (window.innerWidth - width) / 2 + window.screenX;
    const top = (window.innerHeight - height) / 2 + window.screenY;

    return window.open(
      url,
      "_blank",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  const openWhatsApp = () => {
    const shareText = t("join_to_my_affiliate_link");
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      `${shareText}: ${linkValue}`
    )}`;
    openCenteredWindow(whatsappUrl, 600, 500);
  };

  const openEmail = () => {
    const subject = t("affiliate_link");
    const body = `${t("join_to_my_affiliate_link")}: ${linkValue}`;
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
  };

  const openFacebook = () => {
    const shareText = t("join_to_my_affiliate_link");
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      linkValue
    )}&quote=${encodeURIComponent(shareText)}`;
    openCenteredWindow(facebookUrl, 600, 500);
  };

  const openLinkedIn = () => {
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      linkValue
    )}`;
    openCenteredWindow(linkedinUrl, 600, 500);
  };

  return (
    <div className="affiliate-link-sharing-option-wrapper">
      <div className="affiliate-link-sharing-option-title">
        {t("sharing_options")}
      </div>
      <div className="shared-options-links-wrapper">
        <img src={WhatsupIcon} onClick={() => openWhatsApp()} />
        <img src={EmailIcon} onClick={() => openEmail()} />
        <img src={FacebookIcon} onClick={() => openFacebook()} />
        <img src={LinkedinIcon} onClick={() => openLinkedIn()} />
      </div>
    </div>
  );
};
